import { PageHeader } from "@/components/PageHeader/PageHeader";
import { Flex } from "antd";
import ManageAccount from "./ManageAccount";

import useTrackOnLoad from "@/hooks/useTrackPageview";

export default function Account() {
  useTrackOnLoad("Account viewed");

  return (
    <Flex
      vertical
      gap={12}
    >
      <PageHeader title="Account" />
      <ManageAccount />
    </Flex>
  );
}
